import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, Crown } from "lucide-react";
import api from "@/lib/api";
import { inr } from "@/lib/brand";

export default function MembershipSuccessPage() {
  const [m, setM] = useState(null);

  useEffect(() => {
    api.get("/memberships/my").then((r) => setM(r.data.membership)).catch(() => {});
  }, []);

  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="membership-success-page">
      <div className="w-16 h-16 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mx-auto mb-5">
        <CheckCircle2 className="w-9 h-9" />
      </div>
      <h1 className="font-display text-3xl md:text-4xl mb-2">You're in! 🎉</h1>
      <p className="text-stone-500 mb-8">
        Your membership has been activated. All Apartments in Goa are now unlocked for you.
      </p>

      {m && (
        <div className="rounded-2xl border border-stone-200 bg-white p-6 text-left mb-8" data-testid="success-membership-card">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-2xl bg-stone-900 text-amber-300 flex items-center justify-center">
              <Crown className="w-5 h-5" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Plan</div>
              <div className="font-display text-lg">{m.plan_name} Membership</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Amount Paid</div>
              <div className="font-semibold">{inr(m.amount)}</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Duration</div>
              <div className="font-semibold">{m.duration_months} months</div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Purchased</div>
              <div className="font-semibold">
                {m.purchase_date ? new Date(m.purchase_date).toLocaleDateString() : "—"}
              </div>
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest text-stone-500">Valid Till</div>
              <div className="font-semibold">
                {m.valid_till ? new Date(m.valid_till).toLocaleDateString() : "—"}
              </div>
            </div>
            <div className="col-span-2">
              <div className="text-xs uppercase tracking-widest text-stone-500">Payment Reference</div>
              <div className="font-mono text-xs break-all">{m.razorpay_payment_id}</div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Link to="/apartments-in-goa" className="btn-primary" data-testid="success-view-apartments">
          Explore Apartments in Goa
        </Link>
        <Link to="/profile?tab=membership" className="btn-outline" data-testid="success-view-dashboard">
          My Membership
        </Link>
      </div>
    </div>
  );
}
